import * as React from "react"
import { Root, ImageLogo } from "./logo.styled"
import { LogoProps } from "./logo.interface"
import AltLogo from "../../../assets/images/logo.png"
import { isMobileDevice } from "../../../util/browser"
import useWindowSize from "../../../hooks/useWindowSize"
import { isIpad } from "../../../util/deviceType"

const _Logo: React.FC<LogoProps> = ({ src, isLandscape, noPad = false }) => {
  const { screenSize } = useWindowSize()
  const isMobile = React.useMemo<boolean>(
    () => isIpad() === true || isMobileDevice(screenSize),
    [screenSize]
  )

  return (
    <Root isLandscape={isLandscape} noPad={noPad}>
      <ImageLogo
        data={src ? src : AltLogo}
        aria-label=" "
        isMobile={isMobile}
      />
    </Root>
  )
}
export const Logo = React.memo(_Logo)
